module.exports = __webpack_public_path__ + "img/blue_098.f4cbeb1b.png";